import {Injectable} from '@angular/core';

declare var moment: any;

@Injectable()
export class UtilsService {
    constructor() {}

    to2dp(amt) {
        return Math.floor(parseFloat(amt) * 100) / 100;
    }

    ucFirst(string)
    {
        if (string == null || string.length == 0) {
            return string;
        }
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }

    formatAddress(de) {
        if (de == null) return '';
        var address = '';
        address = de.donorAddress1;
        if (de.donorAddress2 != null && de.donorAddress2.length > 0) address += ' ' +de.donorAddress2;
        var csz = '';
        if (de.donorCity != null && de.donorCity.length > 0) csz += de.donorCity;
        if (de.donorState != null && de.donorState.length > 0) csz += (csz.length > 1 ? ', ' : '') + de.donorState;
        if (de.donorPostalCode != null && de.donorPostalCode.length > 0) csz += ' ' + de.donorPostalCode;

        if (csz.length > 0) {
            address += ' - ' + csz;
        }
        return $('<div>').text(address).html();;
    }

    formatPhone(p) {
        if (p.donorPhoneNumber) {
            return (p.donorAreaCode ? '(' + p.donorAreaCode + ')' : '') + ' ' + p.donorPhoneNumber;
        } else {
            return 'N/A';
        }
    }

    isIE() {
        const ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
        const msie = ua.indexOf('MSIE '); // IE 10 or older
        const trident = ua.indexOf('Trident/'); //IE 11
    
        return (msie > 0 || trident > 0);
    }

    fixModelStructure(model, base) {
        for (var k in base)
        {
            if (typeof base[k] == "object" && base[k] !== null) {
                if (model[k] === null || typeof model[k] !== 'object') {
                    model[k] = {};
                }
                this.fixModelStructure(model[k], base[k]);
            } else {
                if (model[k] === null || typeof model[k] === 'undefined') {
                    model[k] = base[k];
                }
            }
        }
        return model;
    }
}
